import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZonelessChangeDetection, Injectable, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { provideOptimus } from '@openng/optimus-ui/config';
import { MessageService } from '@openng/optimus-ui/api';
import { toteimTheme } from './app.theme';
import { appRoutes } from './app.routes';

export function httpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const chunkFailedMessage: RegExp = /Loading chunk [\d]+ failed/;

    if (error.message.includes('ChunkLoadError') || error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Loading chunk') || chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(appRoutes),
    provideHttpClient(withXhr()),
    MessageService,
    provideOptimus({
      theme: {
        preset: toteimTheme(),
        options: {
          prefix: 'p',
          darkModeSelector: '.app-dark',
          cssLayer: {
            name: 'optimus',
            order: 'tailwind-base, optimus, tailwind-utilities, base'
          }
        }
      }
    }),
    importProvidersFrom([TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    })]),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: LOCALE_ID, useValue: 'fr-FR' }
  ]
};
